import Tilt from "./Tilt";

const icon = (path) => (
    <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{path}</svg>
);

const features = [
    {
        title: "Precios al instante",
        body: "Cambiás un precio desde tu cuenta y tus clientes lo ven en el momento.",
        icon: icon(<path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"></path>)
    },
    {
        title: "Un QR que no cambia",
        body: "Lo imprimís una sola vez. Aunque edites todo el catálogo, sigue funcionando.",
        icon: icon(<><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect><path d="M14 14h3v3h-3zM20 20h.01"></path></>)
    },
    {
        title: "Con tus colores",
        body: "Elegí el fondo, las letras y los botones para que se parezca a tu negocio.",
        icon: icon(<><circle cx="12" cy="12" r="9"></circle><path d="M12 3a9 9 0 0 0 0 18c1.5 0 2-1 2-2s-1-1.5-1-2.5 1-1.5 2-1.5h2a4 4 0 0 0 4-4c0-4.4-4-8-9-8z"></path></>)
    },
    {
        title: "Sin bajar apps",
        body: "Tus clientes lo abren con la cámara del celular o desde tu link en redes y WhatsApp.",
        icon: icon(<><rect x="6" y="2" width="12" height="20" rx="2.5"></rect><path d="M11 18h2"></path></>)
    },
    {
        title: "Categorías ordenadas",
        body: "Agrupá tus productos por categoría, cada uno con foto, descripción y precio.",
        icon: icon(<><path d="M4 6h16M4 12h16M4 18h10"></path></>)
    },
    {
        title: "Para cualquier rubro",
        body: "Restaurantes, comercios, peluquerías y profesionales que quieren mostrar sus servicios.",
        icon: icon(<><path d="M3 9l1.5-5h15L21 9"></path><path d="M4 9v11h16V9"></path><path d="M3 9h18"></path><path d="M10 20v-6h4v6"></path></>)
    }
];

const Features = () => {
  return (
    <section className="lp-section">
        <div className="lp-container">
            <h2 data-reveal>Más que una carta en PDF</h2>
            <div className="lp-features">
                {
                    features.map((feature, i) => (
                        <div key={feature.title} className="lp-feature-wrap" data-reveal style={{ "--d": ((i % 3) * 90) + "ms" }}>
                            <Tilt className="lp-feature">
                                <span className="lp-feature-icon">{feature.icon}</span>
                                <h3>{feature.title}</h3>
                                <p>{feature.body}</p>
                            </Tilt>
                        </div>
                    ))
                }
            </div>
        </div>
    </section>
  )
}

export default Features
